"use strict";
/**
 * Informació de Sessió
 * Component: AppSessionInfo.tsx
 * Llenguatge: TypeScrypt
 * Autors:
 * Versió: 1.1
 * Data: 21/05/2020
 * (c) Ajuntament de Manresa - nov 2018 - Departament de Sistemes d'Informació
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var core_1 = require("@material-ui/core");

var indigo_1 = require("@material-ui/core/colors/indigo");

var AccountCircle_1 = require("@material-ui/icons/AccountCircle");

var useMediaQuery_1 = require("@material-ui/core/useMediaQuery/useMediaQuery");

var AppSessionMenu_1 = require("./AppSessionMenu");

var mobx_react_1 = require("mobx-react");

var AppSessionInfo = function AppSessionInfo(props) {
  var theme = core_1.useTheme();
  var upSm = useMediaQuery_1.default(theme.breakpoints.up('sm'));

  var _a = React.useState(null),
      anchorEl = _a[0],
      setAnchorEl = _a[1];

  if (!props.appState || !props.appState.sessState || !props.appState.sessState.esLoginat) {
    return null;
  }

  var _b = props.appState,
      sessState = _b.sessState,
      pantState = _b.pantState;
  var treballador = sessState.treballador;
  var hasHelp = !!sessState.recurs.RECURLHELP && !pantState.hasToolbar;
  var isMenuOpen = Boolean(anchorEl);

  var handleMenuOpen = function handleMenuOpen(event) {
    setAnchorEl(!isMenuOpen && event.currentTarget);
  };

  var handleMenuClose = function handleMenuClose() {
    setAnchorEl(null);
  };

  var handleDisconnect = function handleDisconnect() {
    handleMenuClose();
    pantState.goPantalla('/logout');
  };

  var handleMenuHelp = hasHelp && function () {
    handleMenuClose();
    pantState.goPantalla('/help');
  };

  var colorSubT = indigo_1.default[200];
  var infoTreballador = React.createElement("div", {
    style: {
      textAlign: 'right',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center'
    },
    onClick: handleMenuOpen
  }, upSm && React.createElement("div", null, React.createElement(core_1.Typography, {
    variant: "body1",
    color: "inherit",
    noWrap: true,
    style: {
      lineHeight: '1em'
    }
  }, treballador.nomiCognoms), React.createElement(core_1.Typography, {
    variant: "body2",
    noWrap: true,
    style: {
      color: colorSubT
    }
  }, treballador.llocDesc)), React.createElement(core_1.IconButton, {
    "aria-label": "men\xFA login",
    "aria-haspopup": "true",
    color: "inherit",
    edge: "end"
  }, React.createElement(AccountCircle_1.default, null)));
  return React.createElement(React.Fragment, null, React.createElement(core_1.Tooltip, {
    title: "Men\xFA Sessi\xF3",
    placement: "bottom-end"
  }, infoTreballador), React.createElement(AppSessionMenu_1.default, {
    anchorEl: anchorEl,
    open: isMenuOpen,
    onClose: handleMenuClose,
    onHelp: handleMenuHelp,
    onDisconnect: handleDisconnect,
    treballador: treballador
  }));
};

exports.default = mobx_react_1.inject('appState')(mobx_react_1.observer(AppSessionInfo));